export default __webpack_public_path__ + "static/media/default-avatar-light.10b052d5.svg";